module.exports = __webpack_public_path__ + "img/TeamBuilding.762b7767.svg";